import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MoveDiagonal2 = createReactComponent("MoveDiagonal2", ["svg", defaultAttributes, [["polyline", {
  points: "5 11 5 5 11 5",
  key: "ibd62b"
}], ["polyline", {
  points: "19 13 19 19 13 19",
  key: "17z3m7"
}], ["line", {
  x1: "5",
  y1: "5",
  x2: "19",
  y2: "19",
  key: "12h6nj"
}]]]);
export default MoveDiagonal2;